<div class="container-fluid">
  <div class="row justify-content-start data-container" [formGroup]="frm">
    <div class="col-12">
      <mat-form-field>
        <mat-label>Contraseña actual</mat-label>
        <input
          matInput
          [type]="hidenCurrentPass ? 'password' : 'text'"
          placeholder="Contraseña actual"
          formControlName="oldPassword"
        />
        <mat-icon
          class="action_element"
          matSuffix
          color="primary"
          (click)="hidenCurrentPass = !hidenCurrentPass"
          [svgIcon]="hidenCurrentPass ? 'eye-off' : 'eye'"
        ></mat-icon>

        @if (oldPass.hasError('required')) {
        <mat-error> Campo requerido </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field>
        <mat-label>Contraseña nueva</mat-label>
        <input
          matInput
          [type]="hidenNewPass ? 'password' : 'text'"
          placeholder="Contraseña nueva"
          formControlName="newPassword"
          #pass
        />
        <mat-icon
          class="action_element"
          matSuffix
          color="primary"
          (click)="hidenNewPass = !hidenNewPass"
          [svgIcon]="hidenNewPass ? 'eye-off' : 'eye'"
        ></mat-icon>
        @if (newPass.hasError('pattern')) {
        <mat-error>
          Entre 8 y 16 caracteres. Debe incluir mayúsculas, minúsculas y
          números.
        </mat-error>
        } @if (newPass.hasError('required')) {
        <mat-error> Campo requerido </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field>
        <mat-label>Confirmar contraseña</mat-label>
        <input
          matInput
          [type]="hidenConfirmPass ? 'password' : 'text'"
          placeholder="Confirmar contraseña"
          formControlName="confirmNewPassword"
        />
        <mat-icon
          class="action_element"
          matSuffix
          color="primary"
          (click)="hidenConfirmPass = !hidenConfirmPass"
          [svgIcon]="hidenConfirmPass ? 'eye-off' : 'eye'"
        ></mat-icon>

        @if (confirmPass.hasError('required')) {
        <mat-error> Campo requerido </mat-error>
        } @if ( !confirmPass.hasError('required') &&
        frm.hasError('noEqualsPassword') ) {
        <mat-error> Las contraseñas no coinciden </mat-error>
        }
      </mat-form-field>

      @if ( !confirmPass.hasError('required') &&
      frm.hasError('noEqualsPassword') ) {
      <mat-error> Las contraseñas no coinciden </mat-error>
      }
    </div>
  </div>

  @if (showAction) {
  <div class="row align-items-start justify-content-end">
    <div class="col-auto">
      <button
        class="mb-3 text-white"
        mat-raised-button
        color="primary"
        [disabled]="frm.invalid"
        (click)="save()"
      >
        CAMBIAR CONTRASEÑA
      </button>
    </div>
  </div>
  }
</div>
